import React, { useState } from 'react';
import { getImageUrl } from '../hooks/useImageStorage';

interface StorageImageProps {
  path: string;
  alt: string;
  className?: string;
}

const StorageImage: React.FC<StorageImageProps> = ({ path, alt, className = '' }) => {
  const [hasError, setHasError] = useState(false);

  if (!path || hasError) {
    return (
      <div
        className={`flex items-center justify-center bg-gray-100 text-gray-300 ${className}`}
        role="img"
        aria-label={alt}
      >
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
    );
  }

  return (
    <img
      src={getImageUrl(path)}
      alt={alt}
      className={className}
      onError={() => setHasError(true)}
    />
  );
};

export default StorageImage;
